import {
  CAMPAIGN_TYPE_LABELS,
  type IBannerGalleryItem,
  normalizeMechanic,
} from "@/@types/gamification";

import { BANNER_GALLERY_COPY } from "../constants/messages";

export interface BannerGallerySelection {
  key: string;
  url: string;
  label: string;
}

export function galleryGameLabel(campaignType: string | null): string | null {
  if (!campaignType) return null;
  return CAMPAIGN_TYPE_LABELS[normalizeMechanic(campaignType)];
}

export function galleryItemLabel(item: IBannerGalleryItem): string {
  const campaignName = item.campaignName?.trim();
  if (campaignName) return campaignName;
  const game = galleryGameLabel(item.campaignType) ?? BANNER_GALLERY_COPY.allGames;
  return BANNER_GALLERY_COPY.defaultArt(game);
}

export function toGallerySelection(item: IBannerGalleryItem): BannerGallerySelection {
  return { key: item.key, url: item.url, label: galleryItemLabel(item) };
}

export function bannerSourceKeyFor(
  file: unknown,
  sourceKey: string | undefined,
): string | undefined {
  if (file instanceof File) return undefined;
  return sourceKey || undefined;
}

interface CoverImageValues {
  banner3x4?: unknown;
  banner3x4SourceKey?: string;
}

export function hasCoverImage(values: CoverImageValues): boolean {
  return values.banner3x4 instanceof File || Boolean(values.banner3x4SourceKey);
}

interface WideBannerValues {
  banner16x9?: unknown;
  banner16x9SourceKey?: string;
}

export function hasWideBanner(values: WideBannerValues): boolean {
  return values.banner16x9 instanceof File || Boolean(values.banner16x9SourceKey);
}
